var Handlebars = require("/builds/product/cm/hyperchat-sdk/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper;

  return "Reference for your query: <strong>"
    + container.escapeExpression(((helper = (helper = helpers.ticketId || (depth0 != null ? depth0.ticketId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticketId","hash":{},"data":data}) : helper)))
    + "</strong>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./i18n/en_EN/converted_to_ticket.hbs
// module id = 268
// module chunks = 0